var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "36pt",
    height: "36pt",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1095"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,31.764706%,0%)",
      fillOpacity: 1
    },
    d: "M 30.75 3.75 L 5.25 3.75 L 7.5 29.25 L 18 32.25 L 28.5 29.25 Z M 30.75 3.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,42.745098%,0%)",
      fillOpacity: 1
    },
    d: "M 18 6 L 18 29.925781 L 26.398438 27.523438 L 28.273438 6 Z M 18 6 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18 18.75 L 18 15.75 L 24.449219 15.75 L 23.925781 24.375 L 18 26.324219 L 18 23.175781 L 21.074219 22.125 L 21.300781 18.75 Z M 24.675781 12.75 L 24.898438 9.75 L 18 9.75 L 18 12.75 Z M 24.675781 12.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333333%,93.333333%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 18 23.175781 L 18 26.324219 L 12.074219 24.375 L 11.773438 20.25 L 14.773438 20.25 L 14.925781 22.125 Z M 14.324219 12.75 L 18 12.75 L 18 9.75 L 11.175781 9.75 L 11.699219 18.75 L 18 18.75 L 18 15.75 L 14.550781 15.75 Z M 14.324219 12.75 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.d2ca0912786ad90d21ac12d0e905767c.svg";
export { ForwardRef as ReactComponent };